import SubscribeForm from "~/components/blackFriday/SubscribeForm"
import type { ImageWidget } from "~/types/widgets"
import { Picture, Source } from "~/components/ui/Picture"

export interface Banner {
  desktop: ImageWidget
  mobile: ImageWidget

  /**
   * @title Texto alternativo
   */
  alt: string
}

export interface Form {
  /**
   * @title Título do formulário
   */
  title?: string
}

export interface Props {
  banner?: Banner

  /**
   * @title Título do formulário
   * @format html
   */
  formTitle?: string
}

export default function Subscribe({ banner, formTitle }: Props) {
  if (!banner) return null

  return (
    <div id='subscribe' className='relative'>
      <Picture>
        <Source
          media='(max-width: 767px)'
          src={banner.mobile}
          width={380}
          height={180}
        />

        <Source
          media='(min-width: 768px)'
          src={banner.desktop}
          width={1920}
          height={300}
        />

        <img
          className='w-full object-cover lg:min-h-[320px]'
          src={banner.mobile}
          alt={banner.alt}
          loading='lazy'
        />
      </Picture>

      <div className='max-w-[1220px] h-full mx-auto lg:max-h-[310px] lg:px-3 lg:flex lg:justify-end lg:items-center lg:absolute lg:top-1/2 lg:-translate-y-1/2 lg:bottom-1 lg:left-0 lg:right-0 min-[1240px]:px-0'>
        <div className='w-full h-full py-3 bg-[#f18844] lg:max-w-[436px]'>
          <SubscribeForm title={formTitle} />
        </div>
      </div>
    </div>
  )
}
